<header class="mi-app-header d-flex justify-content-center align-items-center d-md-none mc-py-3">
    <mi-app-menu class="mi-app-menu-el" />

    <div class="d-flex justify-content-center   mi-maslul-logo " (click)="goToHome()" tabindex="0" role="button"
        (keyup.enter)="goToHome()">
        <img src="assets/images/shared/my-import-title.svg" [alt]="commonText?.myImport">
    </div>


</header>
<header class="mi-app-header d-none d-md-flex justify-content-between mc-p-3">
    <div class="d-flex   justify-content-start mi-maslul-logo " (click)="goToHome()" tabindex="0" role="button"
        (keyup.enter)="goToHome()">
        <img src="assets/images/shared/my-import-title.svg" [alt]="commonText?.myImport">
    </div>
    <div class="d-flex mc-w-10 justify-content-evenly align-items-center">

        <!-- <div class="mi-header-language mc-me-4">
            <div class="d-flex  align-items-center " (click)="toggleLanguage()">
                <i class=" icon-world mc-me-1"></i>
                <span>עברית</span>
                <i class="icon-Color-Overlay  mc-ms-1"></i>
            </div>
            @if(isOpenLanguage){
            <ul class="mi-header-language-menu">
                <li><span>עברית</span></li>
                <li><span>english</span></li>

            </ul>
            }
        </div> -->
        <div class="d-flex align-items-center">
            <i class=" icon-phone-call-1 mc-me-2"> </i>
            <span [cdkCopyToClipboard]="'1299'" (click)="onCopy()" tabindex="0" role="button"
                (keyup.enter)="onCopy()">1299</span>

            <!-- @if(isCopied){
            <p style="position: absolute; background-color: white;top: 4rem;">✅ הועתק בהצלחה!</p>

            } -->
        </div>
    </div>


</header>